import { render, staticRenderFns } from "./informatics.vue?vue&type=template&id=68912d2a"
import script from "./informatics.vue?vue&type=script&lang=js"
export * from "./informatics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports